import { Position } from 'geojson'
import { Atom, atom } from 'jotai'
import { vendorsClient } from 'src/clients'
import { PropertyRecordVal } from 'src/common-services'
import { ifNotFound } from 'src/utils/ajax'
import { atomFamily } from 'src/utils/jotai'

export const normalizedAddresByPosition = atomFamily<Position, Atom<Promise<string>>>((position) =>
  atom(async () => {
    const address = await ifNotFound(vendorsClient.properties.getNormalizedAddress(position), '')
    return address
  })
)

export const propertyRecords = atomFamily<string, Atom<Promise<PropertyRecordVal[] | undefined>>>((address) =>
  atom(async () => {
    const data = await ifNotFound(
      vendorsClient.properties.getPropertyRecords({ address, includeUnmask: false }),
      undefined
    )
    return data
  })
)

export const propertyRecordsForPosition = atomFamily<Position, Atom<Promise<PropertyRecordVal[] | undefined>>>(
  (position) =>
    atom(async (get) => {
      const address = await get(normalizedAddresByPosition(position))
      const data = await get(propertyRecords(address))
      return data
    })
)
